import AiSection from './AiSection';
import Programs from "./Programs";
import Slider from "./Slider";
import SuccessStories from "./SuccessStories";

function HomePageComponents() {
  return (
    <div>
      <Slider />
      <AiSection />
      <SuccessStories />
      <Programs />
    </div>
  );
};

export default HomePageComponents;
